export default __webpack_public_path__ + "static/media/1234.bdada615.jpeg";